/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Toast_Reject_PxkInputs */

const vi_scl_toast_reject_pxk = /** @type {(inputs: Scl_Toast_Reject_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã từ chối phiếu`)
};

/**

* @param {Scl_Toast_Reject_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_toast_reject_pxk = /** @type {((inputs?: Scl_Toast_Reject_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Toast_Reject_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_toast_reject_pxk(inputs)
});